<script lang="ts">
  import { observe } from "$lib/actions/observe";
  import { sanitizeSvg } from "$lib/utils/sanitize";

  let {
    sectionLabel = "",
    headline = "",
    posts = [] as Array<{
      date: string;
      category: string;
      title: string;
      description: string;
      url: string;
      thumbSvg?: string;
    }>
  } = $props();
</script>

<section>
  <div class="container">
    {#if sectionLabel}
      <div class="section-divider fade-up" use:observe>
        <span class="section-label">{sectionLabel}</span>
        <h2>{headline}</h2>
      </div>
    {/if}
    <div class="blog-grid stagger" use:observe>
      {#each posts as post}
        <a href={post.url} class="card blog-card" style="display:block">
          {#if post.thumbSvg}
            <div class="card-thumb" style="background:var(--accent-bg);color:var(--accent)" aria-hidden="true">
              {@html sanitizeSvg(post.thumbSvg)}
            </div>
          {:else}
            <div class="card-thumb" style="background:var(--brand-dark);color:oklch(70% 0.01 70);font-family:var(--font-mono);font-size:0.75rem">
              blog-{post.url.replace("/", "")}.svg
            </div>
          {/if}
          <div class="blog-meta">
            <span>{post.date}</span>
            <span style="margin-left:8px" class="tag">{post.category}</span>
          </div>
          <h3>{post.title}</h3>
          <p>{post.description}</p>
        </a>
      {/each}
    </div>
  </div>
</section>
